
import Color from './color'

export default {
  name: 'VsSwatch',
  inheritAttrs: false,
  components: {
    Color
  },
  props: {
    colors: {
      type: Array,
      default: null
    },
    size: {
      type: [String, Object],
      default: 'sm'
    },
    circle: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: true
    },
    gap: {
      type: [String, Object],
      default: 'xs'
    },
    limit: {
      type: Number,
      default: null
    }
  },
  vessel: {
    text: {
      fontSize: 'xs',
      paddingLeft: '2xs'
    },
    color: {
      $shadow: 'shadow',
      $circle: {
        borderRadius: val => val ? 'full': 'lg'
      },
      $size: {
        width: val => val,
        height: val => val
      }
    }
  },
  computed: {
    visibleColors() {
      const value = this.colors || []
      const limit = this.limit || value.length

      return value.filter((item, index) => index < limit)
    },
    hiddenCount() {
      const value = this.colors || []
      const total = value.length
      const limit = this.limit || total

      return total > limit ? total - limit : null
    }
  },
  methods: {
    onClick(color) {
      this.$emit('click', color)
    }
  }
}
